import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

import ReactPaginate from "react-paginate";
import { ToastContainer } from "react-toastify";

import { isEmpty, isEqual, map, size } from "lodash";
import Emitter from "@/utils/Emitter";
import { getFilteredProducts , favoriteProduct } from "@/store/modern/slices/productSlice";
import seoConfig from "@/data/seo.config";
import { publicRoutePaths } from "@/routes/public.routes.config";
import { useAuth } from "@/AuthProvider";
import SeoHelmet from "@/components/SeoHelmet";

import ProductCard from "@/modules/frontend/components/Market_Place/Product/ProductCard";
import ScreenLoaderHome from "@/components/common/ScreenLoaderHome";
import UpFilter from '@/modules/frontend/components/Market_Place/UpFilter';
import SideFilter from "@/modules/frontend/components/Market_Place/SideFilter";
import ConsentManager from "@/modules/frontend/components/ConsentManager";
import PopUp from "@/modules/frontend/components/PopUp";
import BookADemo from "@/modules/frontend/components/BookADemo";
import RegistrationPopup from "@/components/RegistrationPopup";
import SupplierInqPopup from "@/modules/frontend/components/Inquiry/SupplierInqPopup";

import no_data_found from "@/assets/images/svg/no_data_found.svg";
import Agriculture from "@/assets/images/webp/product-banner/agriculture-banner.webp";
import AutoMobile from "@/assets/images/webp/product-banner/Automobile-&-Auto-Parts.webp";
import Building from "@/assets/images/webp/product-banner/Building-Materials.webp";
import Ceramic from "@/assets/images/webp/product-banner/Ceramic.webp";
import Common from "@/assets/images/webp/product-banner/common-banner.webp";
import Cosmetic from "@/assets/images/webp/product-banner/Cosmetics-&-Personal-Care.webp";
import Electronics from "@/assets/images/webp/product-banner/Electronics-&-Gadgets.webp";
import FMCG from "@/assets/images/webp/product-banner/FMCG.webp";
import Food from "@/assets/images/webp/product-banner/Food-Products.webp";
import OilGas from "@/assets/images/webp/product-banner/Oil-&-Gas.webp";
import Pharmaceuticals from "@/assets/images/webp/product-banner/Pharmaceuticals.webp";
import Textiles from "@/assets/images/webp/product-banner/Textiles.webp";

import MobAgriculture from "@/assets/images/webp/market-place-banner/agriculture.webp";
import MobAutoMobile from "@/assets/images/webp/market-place-banner/automobile-&-Auto-Parts.webp";
import MobBuilding from "@/assets/images/webp/market-place-banner/building-Materials.webp";
import MobCeramic from "@/assets/images/webp/market-place-banner/ceramic.webp";
import MobCommon from "@/assets/images/webp/market-place-banner/common-banner.webp";
import MobCosmetic from "@/assets/images/webp/market-place-banner/cosmetics-&-Personal-Care.webp";
import MobElectronics from "@/assets/images/webp/market-place-banner/electronics-&-Gadgets.webp";
import MobFMCG from "@/assets/images/webp/market-place-banner/FMCG.webp";
import MobFood from "@/assets/images/webp/market-place-banner/food-Products.webp";
import MobOilGas from "@/assets/images/webp/market-place-banner/oil-&-Gas.webp";
import MobPharmaceuticals from "@/assets/images/webp/market-place-banner/pharmaceuticals.webp";
import MobTextiles from "@/assets/images/webp/market-place-banner/textiles.webp";
import { showSuccessMessage,buildPath } from "@/utils/common";
import roles from "@/constant/roles.config";
import { createplanReq } from "@/store/modern/slices/requestslice";
import { privateRoutePaths } from "@/routes/private.route.config";

const CATEGORY_MAP = {
  agriculture: { img: Agriculture, label: "Agriculture", category: "agriculture", mobImg: MobAgriculture, seoKey: "filter_africulture" },
  pharmaceuticals: { img: Pharmaceuticals, label: "Pharmaceuticals", category: "pharmaceuticals", mobImg: MobPharmaceuticals, seoKey: "filter_pharma" },
  ceramic: { img: Ceramic, label: "Ceramics", category: "ceramic", mobImg: MobCeramic, seoKey: "filter_ceramic" },
  textiles: { img: Textiles, label: "Textiles", category: "textiles", mobImg: MobTextiles, seoKey: "filter_textiles" },
  "building-materials": { img: Building, label: "Building Materials", category: "building-materials", mobImg: MobBuilding, seoKey: "filter_building_materials" },
  "automobile-and-auto-parts": { img: AutoMobile, label: "Automobile & Auto Parts", category: "automobile-and-auto-parts", mobImg: MobAutoMobile, seoKey: "filter_automobile" },
  fmcg: { img: FMCG, label: "FMCG", category: "fmcg", mobImg: MobFMCG, seoKey: "filter_fmcg" },
  "cosmetics-and-personal-care": { img: Cosmetic, label: "Cosmetics & Personal Care", category: "cosmetics-and-personal-care", mobImg: MobCosmetic, seoKey: "filter_cosmetic" },
  "food-products": { img: Food, label: "Food Products", category: "food-products", mobImg: MobFood, seoKey: "filter_food_products" },
  "electronics-and-gadgets": { img: Electronics, label: "Electronics & Gadgets", category: "electronics-and-gadgets", mobImg: MobElectronics, seoKey: "filter_electronics" },
  "oil-gas": { img: OilGas, label: "Oil & Gas", category: "oil-gas", mobImg: MobOilGas, seoKey: "filter_oil" },
  all: { img: Common, label: "All", category: "", mobImg: MobCommon, seoKey: "filterProducts" },
};

function MarketDetail() {
  // eslint-disable-next-line react-hooks/rules-of-hooks

  const [searchParams, setsearchParams] = useSearchParams();
  const { user, isEndUser, isPreKYCUser, isDemoUser, isViewer } = useAuth();

  let category = searchParams.get("category");
  const initialMatch = CATEGORY_MAP[category];

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const products = useSelector((state) => state.products.list, shallowEqual);
  const productMeta = useSelector((state) => state.products.list.metadata, shallowEqual);

  const [filterObj, setFilterObj] = useState({
    business_type: "",
    supplier_country: "",
    category: initialMatch?.category ?? "-",
    search_txt: "",
    filterKeys: [],
    offset: 0,
    limit: 9
  });

  const [loader, setLoader] = useState(false);
  const [smallmodalShow, setSmallModalShow] = useState(false);
  const [inqmodalshow, setInqModalShow] = useState(false);
  const [regmodalShow, setRegModalShow] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [showContact, setShowContact] = useState(false);
  const [registerModalShow, setRegisterModalShow] = useState(false);

  const bkImg = useRef("");
  const mobbkImg = useRef("");
  const catRef = useRef("");
  const catKeyRef = useRef("filterProducts");

  let pageCount = 0;

  if (productMeta) {
    pageCount = Math.ceil(productMeta.total / productMeta.limit);
  }

  const getPrefix = () => {
    if (user && isPreKYCUser) return roles.PRE_KYC.prefix;
    if (user && isDemoUser) return roles.DEMO.prefix;
    if (user && isEndUser) return roles.END_USER.prefix;
    if (user && isViewer) return roles.VIEWER.prefix;
    return roles.SUPER_ADMIN.prefix;
  };

  const handleQuoteClick = () => {
    setSmallModalShow(true);
  };

  const handleRegistrationPopup = () => {
    let path = publicRoutePaths.REGISTRATION.path;
    navigate(path);
  }

  const handleUpgradePlanClick = async () => {
    if (user) {
      let data = {
        member_id: user.member_id
      }
      const response = await dispatch(createplanReq(data));
      if (response) {
        if (response.type === "upgradePlan/createRequest/fulfilled") {
          setRegModalShow(false);
          // setInqModalShow(false);
          if (user.trade_mode_type !== 'SUPPLIER') {
           showSuccessMessage("We have received your upgrade request. Our team will contact you soon.")
          } else {
              setTimeout(() => {
                  navigate(`/${getPrefix(user)}${buildPath(privateRoutePaths.ADMIN_CHOOSE_PLAN, { id: user.member_id })}`)
              }, 500);
             
            
          }
           
        }
      }
    }
  }
  console.log("USER",user);
  const redirectFun = (e, id) => {
    e.preventDefault();
    setRegModalShow(false);


    setTimeout(() => {
      // navigate(publicRoutePaths.REGISTRATION.path);
      window.open(publicRoutePaths.REGISTRATION.path);
    }, 100);

  };

  const handleInqQuoteClick = (pdata) => {
    let sdata = { ...pdata.company };
    sdata.selected_product_id = pdata.id;
    console.log("isEndUser here",isEndUser)
    setSelectedSupplier(sdata);

    //  if (user && (isEndUser || user.trade_mode_type === "BUYER")) {
    //     setRegModalShow(false);
    //     setInqModalShow(true);
    //   } else if (user && user.trade_mode_type === "SUPPLIER" && user.company_plan_name !== "Trial") {
    //     setRegModalShow(false);
    //     setInqModalShow(true);
    //   } else {
    //     setRegModalShow(true);
    //   }
    if (user && (isEndUser || user.trade_mode_type === "BUYER")) {
      setInqModalShow(true);
    } else {
      setRegModalShow(true);
    }
  }

  const handlePageClick = async (event) => {
    let selctedIndex = event.selected + 1;
    let offsetVal = 0;
    if (selctedIndex === 1) {
      offsetVal = 0;
    } else {
      offsetVal = (selctedIndex - 1) * filterObj.limit;
    }

    const fObj = {
      ...filterObj,
      offset: offsetVal,
    };

    setFilterObj(fObj);

    await filterProducts(fObj);
    window.scrollTo(0, 0);
  }

  const filterProducts = (reqObj) => {
    // console.log("filterProducts >>>>>>>", reqObj);
    setLoader(true);
    dispatch(getFilteredProducts(reqObj));
    setTimeout(() => {
      setLoader(false);
    }, 2000);
  }

  const setProductFilter = async (val) => {
    setFilterObj({ ...val });
    await filterProducts(val);
  }

  const handleInqClick = () => {
    setRegModalShow(false);
    setInqModalShow(true);
  }

  const handlefavoriteClick = async (pdata) => {
    if(user) {
      let reqObj = {
        product_id : pdata.id
      }
      const response = await dispatch(favoriteProduct(reqObj));
      if(response && response.type === "products/favoriteProduct/fulfilled") {
        if(response.payload.status) {
          showSuccessMessage(response.payload.message);
          setTimeout(() => {
            let fObj = { ...filterObj };
            filterProducts(fObj);
          },1000);
          
        }
      }
    } else {
      setRegisterModalShow(true);
    }
  }

  const handleRegisterBtnClick = () => {
    navigate(publicRoutePaths.REGISTRATION.path);
  }

  useEffect(() => {
    let c = category;
    if (isEmpty(c)) {
      c = "all";
    }
    const match = CATEGORY_MAP[c];
    bkImg.current = match?.img ?? "";
    mobbkImg.current = match?.mobImg ?? "";

    catRef.current = match?.label ?? "";
    catKeyRef.current = match?.seoKey ?? "filterProducts";

    setFilterObj(prev => ({
      ...prev,
      category: match?.category ?? "",
      offset: 0,
    }));

    let fObj = { ...filterObj };
    fObj.category = match?.category ?? "";
    fObj.offset = 0;


    filterProducts(fObj);

  }, [category]);

  useEffect(() => {
    if (user) {
      console.log("User ============ ", user, " ======= isPreKYCUser ========== ", isPreKYCUser, " =========== isEndUser ==========  ", isEndUser)
      if (isPreKYCUser || isEndUser) {
        console.log("If  ============ ")
        if (user.trade_mode_type === "LOG_PTR") {
          setShowContact(false);
        } else {
          setShowContact(true);
        }
      }
    } else {
      setShowContact(true);
    }
  }, [user, isPreKYCUser, isEndUser]);

  console.log("Outside User ============ ", user, " ======= isPreKYCUser ========== ", isPreKYCUser, " =========== isEndUser ==========  ", isEndUser, showContact)

  useEffect(() => {
    Emitter.on("SET_PRODUCT_FILER", setProductFilter);
    return () => Emitter.off("SET_PRODUCT_FILER", setProductFilter);
    //Emitter.on("FILTER_PRODUCTS", filterProducts)
  }, []);

 useEffect(() => {
    console.log("regmodalShow:", regmodalShow);
    console.log("user:", user);

    if (
        regmodalShow &&
        user?.trade_mode_type === "SUPPLIER" &&
        user?.company_plan_name !== "Trial"
    ) {
        console.log("Supplier paid user - switching modal");

        if(isPreKYCUser) {
            setInqModalShow(false);
            setRegModalShow(true);
            
          } else {
            setRegModalShow(false);
            setInqModalShow(true);
          }
    }
}, [regmodalShow, user,isPreKYCUser]);

  //  useEffect(() => {

  //     setInterval(() => {
  //       let u = localStorage.getItem("user");
  //       u = JSON.parse(u);
  //       if(!isEqual(u, user) && user?.company_plan_name !== "Trial" && parseInt(user?.current_step) === 4) {
  //         window.location.reload();
  //       }
  //     },1500);
  //  },[user]);
  useEffect(() => {
  const intervalId = setInterval(() => {
    try {
      const stored = JSON.parse(localStorage.getItem("user"));

      if (
        stored &&
        !isEqual(stored, user) &&
        stored.company_plan_name !== "Trial" &&
        parseInt(stored.current_step) === 4
      ) {
        clearInterval(intervalId);
        window.location.reload();
      }
    } catch (e) {
      console.error("Invalid user in localStorage", e);
    }
  }, 1500);

  return () => clearInterval(intervalId); // cleanup
}, [user]);

  console.log("user =====",user);

  console.log("products =====",products);


  return (
    <section className="market-place-wrape market-detail">
      <SeoHelmet
        title={seoConfig.filterProducts.title}
        description={seoConfig.filterProducts.description}
        keywords={seoConfig[catKeyRef.current].keywords}
        author={seoConfig.filterProducts.author}
      />

      <button
        className="btn outline small sticky-btn"
        onClick={handleQuoteClick}
        type="button"
      >
        Book A Demo
      </button>

      {/* inner banner wrape START */}
      {loader && <ScreenLoaderHome />}
      <div className="inner-banner ipad-hide" style={{ background: `url(${bkImg.current})` }}>
        <div className="container">
          <div className="content-wrape desk-hide">
            <h2>
              {!isEmpty(catRef.current) ? catRef.current : ""}
            </h2>
          </div>
        </div>
      </div>
      {/* inner banner wrape END */}

      {/* mobile inner banner wrape START */}
      <div className="marketplace-banner mobile-banner mobile-show">
        {/* Agriculture ipad banner here */}
        <img src={mobbkImg.current} alt="" className="mob-banner" />
      </div>
      {/* mobile inner banner wrape END */}

      <div className="bradcrumb-wrape">
        <div className="container">
          <ul>
            <li>
              <Link to={publicRoutePaths.HOME.path} title="Home">Home</Link>
            </li>
            <li>
              <Link to={publicRoutePaths.MARKET_PLACE.path} title="Market Place">Market Place</Link>
            </li>
            <li>
              {!isEmpty(catRef.current) ? catRef.current : ""}
            </li>
          </ul>
        </div>
      </div>

      <div className="inner-page-content-wrape market-place-page">
        <div className="container introduction">
          <div className="content-wrape mobile-show page-head">
            <h2 className="mobile-head-text">
              {!isEmpty(catRef.current) ? catRef.current : ""}
            </h2>
          </div>
        </div>

        <div className='container'>
          <div className='row'>
            <div className='col-xxl-3 col-xl-3 col-lg-3 col-md-5'>
              <SideFilter filterObj={filterObj} />
            </div>
            <div className='col-xxl-9 col-xl-9 col-lg-9 col-md-7'>
              <UpFilter filterObj={filterObj} category={catRef.current} />

              <div className="row">
                {
                  products && products.status === true && map(products.data, (product, key) => {
                    return (<div className="col-xxl-4 col-xl-6 col-lg-6 col-md-12"> <ProductCard key={`product_${product.id}`} favKey={`fav_product_${product.id + '_'+ Date.now()}`} data={product} showContact={(user && user.member_id == product.member_id) ? false : showContact} handleQuoteClick={handleInqQuoteClick} showDesc={false} showPrice={true} handlefavoriteClick={handlefavoriteClick} /></div>)
                  })
                }
              </div>

              <div className={`${size(products.data) > 0 ? "bottom-control-wrape" : ""}`}>
                <div className="pagination-wrape">
                  {
                    pageCount > 1 && <ReactPaginate
                      //key={tableKey}
                      nextLabel=""
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={2}
                      marginPagesDisplayed={2}
                      pageCount={pageCount}
                      previousLabel=""
                      pageClassName="number"
                      pageLinkClassName="number"
                      previousClassName="prev"
                      previousLinkClassName="prev"
                      nextClassName="next"
                      nextLinkClassName="next"
                      breakLabel="..."
                      breakClassName="page-item"
                      breakLinkClassName="page-link"
                      containerClassName="pagination"
                      activeClassName="active"
                      renderOnZeroPageCount={null}
                    />
                  }

                </div>
                <div className="page-count-wrape">
                  {
                    productMeta && productMeta.total > 0 && `${(productMeta.offset) + 1}-${(productMeta.offset + productMeta.count)} of ${productMeta.total}`
                  }
                </div>
                {productMeta && productMeta.total === 0 &&
                  <div className="no-data"><img src={no_data_found} alt='No blog found.' /></div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      <ConsentManager />

      {smallmodalShow && (
        <PopUp
          title="Book A Demo"
          smallmodalShow={smallmodalShow}
          setSmallModalShow={setSmallModalShow}
          className="book-demo"
        >
          <BookADemo
            setSmallModalShow={setSmallModalShow} />
        </PopUp>
      )}

      {
        inqmodalshow && (
          <PopUp
            title="Business Inquiry"
            smallmodalShow={inqmodalshow}
            setSmallModalShow={setInqModalShow}
            className="book-demo"
            size="lg"
          >
            <SupplierInqPopup data={selectedSupplier} setInqModalShow={setInqModalShow} from={!user ? "continue_buyer" : ""} />
          </PopUp>
        )
      }

      {
        regmodalShow && <RegistrationPopup
          title=""
          smallmodalShow={regmodalShow}
          setSmallModalShow={setRegModalShow}
          onSubmit={handleRegistrationPopup}
          okButtonLabel={'REGISTER NOW'
          }
        >
          {(() => {
            if (user && isPreKYCUser) {
              return (
                <>
                  <div className="new-pop">
                    <div className="img-wrape"></div>
                    <div className="detail-wrape">
                      <div className="inner">
                        <h5 className="registor-now">Upgrade Required!</h5>
                        <h6>Upgrade now to get more benefits!</h6>
                        <p className="registor-now-text">
                          Upgrade your plan to start connecting with sellers and raising inquiries.
                        </p>
                        {/* <Link to={`/${getPrefix()}${buildPath(privateRoutePaths.UPDATE_COMPANY_PROFILE, { id: user.member_id })}`} className="btn secondry-btn" onClick={(e) => {
                          redirectFun(e, user.member_id)
                        }}>
                          Go to Profile
                        </Link> */}
                        <button type="button" className="btn secondry-btn" onClick={handleUpgradePlanClick}>
                          Upgrade Plan
                        </button>
                      </div>
                    </div>
                  </div>
                </>
              );
            } else {
        
              return (

                <div className="new-pop">
                  <div className="img-wrape"></div>
                  <div className="detail-wrape">
                    <div className="inner">
                      <h5 className="registor-now">Grow With Us!</h5>
                      <p>
                        Select your role to get started:
                      </p>
                      <Link
                        to={publicRoutePaths.REGISTRATION.path}
                        className="popup-category-btn"
                        onClick={(e) => {
                          redirectFun(e, null)
                        }}
                      >
                        <span className="icon supplier"></span>
                        <span className="detail">
                          <h3>Supplier</h3>
                          <p>Sell and showcase your products</p>
                        </span>
                        {/* <p>
                          <span>Sell and showcase your products</span>
                        </p>Supplier */}

                      </Link>
                      <Link
                        to={publicRoutePaths.REGISTRATION.path}
                        className="popup-category-btn"
                        onClick={(e) => {
                          redirectFun(e, null)
                        }}
                      >
                        <span className="icon logistics"></span>
                        <span className="detail">
                          <h3>Logistic Partner</h3>
                          <p>Scaling Your Growth Through Reliable Logistics</p>
                        </span>

                      </Link>
                      <button type="button" className="popup-category-btn" onClick={handleInqClick}>
                        <span className="icon buyer"></span>
                        <span className="detail">
                          <h3>Buyer</h3>
                          <p>Discover and connect with suppliers</p>
                        </span>
                        {/* Buyer
                        <p>
                          <span>Discover and connect with suppliers</span>
                        </p> */}
                      </button>

                    </div>
                  </div>
                </div>
              );
            }
          })()}
        </RegistrationPopup>
      }


      {
        registerModalShow && <RegistrationPopup
        title=""
        smallmodalShow={registerModalShow}
        setSmallModalShow={setRegisterModalShow}
        onSubmit={handleRegisterBtnClick}
        okButtonLabel="REGISTER NOW"
      >
        <div className="new-pop">
          <div className="img-wrape"></div>
          <div className="detail-wrape">
            <div className="inner">
              <h5 className="registor-now">Grow With Us!</h5>
              <h6>Register now to get more benefits!</h6>
              <p className="registor-now-text">
                Access special features, get personalized recommendations and connect with a growing community.
              </p>
              <Link to={publicRoutePaths.REGISTRATION.path} className="btn secondry-btn" target="_blank" href={publicRoutePaths.REGISTRATION.path} >Register Now</Link>
            </div>
          </div>
        </div>
      </RegistrationPopup>
      }

      <ToastContainer />
    </section>
  )
}

export default MarketDetail;
